import type {
  CarkCevirIstegi,
  CarkDurumu,
  CarkSonucu,
  DavetDurumu,
  Liderlik,
} from "@koclukpanel/contracts";
import { api } from "./api";

/**
 * ÇARK / LİDERLİK / DAVET UÇLARI — öğrenci (dalga 2 / 7b). Kapsam ve IDOR SUNUCUDA; bu dosya yalnız ince çağrılar.
 * Sözleşme: packages/contracts/src/oyun-b.ts (tipler ve istek gövdeleri oradan; yol ve gövde sunucu controller'larıyla
 * aynıdır: `cark.controller.ts`, `liderlik.controller.ts`, `davet.controller.ts`).
 *
 * Modül ya da çark kapalıyken sunucu 404 döner; ekranlar bunu "kapalı" diye gösterir, hata saymaz.
 */

export function carkDurumu(): Promise<CarkDurumu> {
  return api("/oyun/cark");
}

/**
 * `istekKimligi` İSTEMCİ UUID'si: aynı kimlikle tekrar istek AYNI sonucu döndürür, ikinci çevirme olmaz.
 * Hak yoksa sunucu 409 `HAK_YOK` döner (gövde: `CarkHakYokHatasi`).
 */
export function carkCevir(govde: CarkCevirIstegi): Promise<CarkSonucu> {
  return api("/oyun/cark/cevir", { yontem: "POST", govde });
}

/** Varsayılan: geçen haftanın KESİN tablosu. Sınıf sunucuda öğrencinin kaydından okunur, istemci göndermez. */
export function liderlikGetir(hafta?: string): Promise<Liderlik> {
  return api("/oyun/liderlik", { sorgu: { hafta } });
}

export function davetDurumu(): Promise<DavetDurumu> {
  return api("/oyun/davet");
}

/** Kodu oluşturur ya da mevcut kodu döndürür (idempotent). */
export function davetKoduAl(): Promise<DavetDurumu> {
  return api("/oyun/davet", { yontem: "POST" });
}
